import { gql } from '@apollo/client';
import { insuranceFragment, hotelFragment } from 'store/fragments';
import { booking, leg, passenger, product } from '../queries/GET_BOOKING';

export default gql`
  mutation waiveOfflineFees($bookingReference: String!, $reason: String) {
    waiveOfflineFees(bookingReference: $bookingReference, reason: $reason) {
      ${booking}
    }
  }
  ${insuranceFragment}

  ${hotelFragment}

  ${leg}

  ${passenger}

  ${product}
`;
